    <div class="channel-types">
        <div class="channel-title">
            {{ 'store.grid.bulkEdit.pos.' + groupType + ".title" | translate  }}
        </div>
        <div class="channel-description">
            {{ 'store.grid.bulkEdit.pos.' + groupType + ".description" | translate }}
        </div>
        <mat-slide-toggle class="update-type"
                          [checked]="updateTypeValue"
                          *ngIf="groupType === 'dispositions' && groupItemsCount"
                          (change)="changeUpdateType($event)">
                {{ (updateTypeValue ? 'store.grid.bulkEdit.pos.updateTypeUpdate' : 'store.grid.bulkEdit.pos.updateTypeReplace' ) | translate }}
        </mat-slide-toggle>

        <div class="dispositions" *ngIf="groupItemsCount">
            <ng-container
                *ngFor="let item of form['controls']| keyvalue; let i = index;">
                <div class="disposition" [formGroup]="$any(item.value)">
                    <ng-container *ngFor="let field of fields">

                        <mat-form-field class="grid-item" *ngIf="field.type !== 'boolean'">

                            <mat-label>{{  field.label }}</mat-label>

                            <ng-container *ngIf="field.type === 'select'">
                                <mat-select [formControlName]="field.key"
                                            matInput>
                                    <mat-option *ngFor="let  option of field.options" [value]="option">
                                        {{ option }}
                                    </mat-option>
                                </mat-select>
                            </ng-container>

                            <ng-container *ngIf="field.type === 'string'">
                                <input matInput
                                       [formControlName]="field.key">
                            </ng-container>

                            <ng-container *ngIf="field.type === 'number'">
                                <input matInput
                                       txpIntegersOnly
                                       [formControlName]="field.key">
                            </ng-container>

                            <mat-hint *ngIf="field.type === 'number' &&  !field.hint">{{ 'form.hint.integersOnly' |
                                translate
                                }}</mat-hint>

                            <mat-hint *ngIf="field.hint">{{ field.hint }}</mat-hint>

                            <mat-error *ngIf="$any(item.value[field.key])?.hasError('required')">
                                {{ 'form.error.required' | translate}}
                            </mat-error>

                            <mat-error *ngIf="$any(item.value[field.key])?.hasError('max')">
                                {{ 'form.error.max' | translate:{ value: field.max} }}
                            </mat-error>

                        </mat-form-field>

                        <mat-form-field class="grid-item" *ngIf="field.type === 'boolean'">
                            <ng-container *ngIf="field.type === 'boolean'">
                                <input matInput type="number" hidden="true">
                                <mat-checkbox [formControlName]="field.key">
                                    {{ field.label }}
                                </mat-checkbox>
                            </ng-container>
                            <mat-hint *ngIf="field.hint">{{ field.hint }}</mat-hint>
                            <mat-error *ngIf="form.get(field.key)?.hasError('required')">
                                {{ 'form.error.required' | translate}}
                            </mat-error>
                        </mat-form-field>

                    </ng-container>


                    <txp-button data-qa-label="RemoveDispositionButton"
                                [style]="buttonStyle.SECONDARY"
                                 icon="tce-icon-trash"
                                (click)="removeGroupItem(i)">
                        {{ 'form.button.remove' | translate }}
                    </txp-button>
                </div>
            </ng-container>
        </div>

        <txp-button class="add-group"
                    data-qa-label="addGroupButton"
                    [style]="buttonStyle.SECONDARY"
                    (click)="addGroupItems()">
            {{ 'store.grid.bulkEdit.pos.addGroupBtn.'+ groupType | translate}}
        </txp-button>
    </div>
